import React from 'react';

const CloudIcon = ({ intensidade, cor, size = 32, chuva15min = 0 }) => {
  const getCloudStyle = () => {
    const baseStyle = {
      width: `${size}px`,
      height: `${size}px`,
      position: 'relative',
      display: 'inline-block',
      cursor: 'pointer',
    };

    return baseStyle;
  };

  const getSvgContent = () => {
    // SVG do sol para sem chuva, nuvem para chuva
    const animationClass = intensidade === 'sem_chuva' ? '' : 'animate-rain';

    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        style={{
          filter:
            intensidade !== 'sem_chuva'
              ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
              : 'drop-shadow(0 2px 4px rgba(255,215,0,0.3))',
        }}
      >
        {intensidade === 'sem_chuva' ? (
          // Sol amarelo para sem chuva
          <g>
            {/* Raios do sol */}
            <g stroke="#FFD700" strokeWidth="2" strokeLinecap="round">
              <line x1="16" y1="4" x2="16" y2="7" />
              <line x1="16" y1="25" x2="16" y2="28" />
              <line x1="4" y1="16" x2="7" y2="16" />
              <line x1="25" y1="16" x2="28" y2="16" />
              <line x1="7.5" y1="7.5" x2="9.5" y2="9.5" />
              <line x1="22.5" y1="22.5" x2="24.5" y2="24.5" />
              <line x1="7.5" y1="24.5" x2="9.5" y2="22.5" />
              <line x1="22.5" y1="9.5" x2="24.5" y2="7.5" />
            </g>
            {/* Círculo do sol */}
            <circle cx="16" cy="16" r="7" fill="#FFD700" stroke="#FFA500" strokeWidth="1" />
            {/* Brilho interno */}
            <circle cx="16" cy="16" r="5" fill="#FFFF99" opacity="0.6" />
          </g>
        ) : (
          // Nuvem para chuva
          <path
            d="M24 14c0-4.4-3.6-8-8-8s-8 3.6-8 8c0 0.6 0.1 1.2 0.2 1.8C6.8 16.4 6 17.6 6 19c0 2.2 1.8 4 4 4h14c2.2 0 4-1.8 4-4C28 16.8 26.2 14 24 14z"
            fill={cor}
            stroke="#666"
            strokeWidth="1"
          />
        )}

        {/* Gotas de chuva animadas para intensidades diferentes */}
        {intensidade !== 'sem_chuva' && (
          <g className={animationClass}>
            {/* Gotas baseadas na intensidade */}
            {intensidade === 'fraca' && (
              <>
                <circle cx="12" cy="26" r="1" fill="#4A90E2" opacity="0.7">
                  <animate attributeName="cy" values="26;30;26" dur="1.5s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.7;0;0.7" dur="1.5s" repeatCount="indefinite" />
                </circle>
                <circle cx="20" cy="28" r="1" fill="#4A90E2" opacity="0.7">
                  <animate attributeName="cy" values="28;32;28" dur="1.8s" repeatCount="indefinite" begin="0.3s" />
                  <animate
                    attributeName="opacity"
                    values="0.7;0;0.7"
                    dur="1.8s"
                    repeatCount="indefinite"
                    begin="0.3s"
                  />
                </circle>
              </>
            )}

            {intensidade === 'moderada' && (
              <>
                <circle cx="10" cy="26" r="1.5" fill="#4A90E2" opacity="0.8">
                  <animate attributeName="cy" values="26;30;26" dur="1.2s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.8;0;0.8" dur="1.2s" repeatCount="indefinite" />
                </circle>
                <circle cx="16" cy="27" r="1.5" fill="#4A90E2" opacity="0.8">
                  <animate attributeName="cy" values="27;31;27" dur="1.4s" repeatCount="indefinite" begin="0.2s" />
                  <animate
                    attributeName="opacity"
                    values="0.8;0;0.8"
                    dur="1.4s"
                    repeatCount="indefinite"
                    begin="0.2s"
                  />
                </circle>
                <circle cx="22" cy="26" r="1.5" fill="#4A90E2" opacity="0.8">
                  <animate attributeName="cy" values="26;30;26" dur="1.3s" repeatCount="indefinite" begin="0.4s" />
                  <animate
                    attributeName="opacity"
                    values="0.8;0;0.8"
                    dur="1.3s"
                    repeatCount="indefinite"
                    begin="0.4s"
                  />
                </circle>
              </>
            )}

            {(intensidade === 'forte' || intensidade === 'muito_forte') && (
              <>
                <line x1="9" y1="26" x2="11" y2="30" stroke="#4A90E2" strokeWidth="2" opacity="0.9">
                  <animate attributeName="y1" values="26;30;26" dur="0.8s" repeatCount="indefinite" />
                  <animate attributeName="y2" values="30;34;30" dur="0.8s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.9;0;0.9" dur="0.8s" repeatCount="indefinite" />
                </line>
                <line x1="15" y1="27" x2="17" y2="31" stroke="#4A90E2" strokeWidth="2" opacity="0.9">
                  <animate attributeName="y1" values="27;31;27" dur="0.9s" repeatCount="indefinite" begin="0.1s" />
                  <animate attributeName="y2" values="31;35;31" dur="0.9s" repeatCount="indefinite" begin="0.1s" />
                  <animate
                    attributeName="opacity"
                    values="0.9;0;0.9"
                    dur="0.9s"
                    repeatCount="indefinite"
                    begin="0.1s"
                  />
                </line>
                <line x1="21" y1="26" x2="23" y2="30" stroke="#4A90E2" strokeWidth="2" opacity="0.9">
                  <animate attributeName="y1" values="26;30;26" dur="0.7s" repeatCount="indefinite" begin="0.2s" />
                  <animate attributeName="y2" values="30;34;30" dur="0.7s" repeatCount="indefinite" begin="0.2s" />
                  <animate
                    attributeName="opacity"
                    values="0.9;0;0.9"
                    dur="0.7s"
                    repeatCount="indefinite"
                    begin="0.2s"
                  />
                </line>

                {intensidade === 'muito_forte' && (
                  <>
                    <line x1="12" y1="25" x2="14" y2="29" stroke="#4A90E2" strokeWidth="2" opacity="0.9">
                      <animate attributeName="y1" values="25;29;25" dur="0.6s" repeatCount="indefinite" begin="0.3s" />
                      <animate attributeName="y2" values="29;33;29" dur="0.6s" repeatCount="indefinite" begin="0.3s" />
                      <animate
                        attributeName="opacity"
                        values="0.9;0;0.9"
                        dur="0.6s"
                        repeatCount="indefinite"
                        begin="0.3s"
                      />
                    </line>
                    <line x1="18" y1="25" x2="20" y2="29" stroke="#4A90E2" strokeWidth="2" opacity="0.9">
                      <animate attributeName="y1" values="25;29;25" dur="0.5s" repeatCount="indefinite" begin="0.4s" />
                      <animate attributeName="y2" values="29;33;29" dur="0.5s" repeatCount="indefinite" begin="0.4s" />
                      <animate
                        attributeName="opacity"
                        values="0.9;0;0.9"
                        dur="0.5s"
                        repeatCount="indefinite"
                        begin="0.4s"
                      />
                    </line>
                  </>
                )}
              </>
            )}
          </g>
        )}

        {/* Texto com quantidade de chuva */}
        {chuva15min > 0 && (
          <text
            x="16"
            y="12"
            textAnchor="middle"
            fontSize="7"
            fill="#000"
            fontWeight="bold"
            style={{ textShadow: '1px 1px 1px rgba(255,255,255,0.8)' }}
          >
            {parseFloat(chuva15min).toFixed(2)}mm
          </text>
        )}
      </svg>
    );
  };

  return (
    <div
      style={getCloudStyle()}
      title={`Chuva: ${parseFloat(chuva15min).toFixed(2)}mm (últimos 15min) - ${intensidade.replace('_', ' ')}`}
    >
      {getSvgContent()}
    </div>
  );
};

export default CloudIcon;
